'use client';

import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { useListingCTAs } from '@/src/components/features/property/hooks/useListingCTAs';
import { Button } from '@zillow/constellation-10';

type Props = {
  listing: PropertyDetailListing;
};

/**
 * Mobile sticky footer CTAs — Contact / Tour / Apply buttons rendered
 * inside ListingPage's `spokeFooterCTAs` slot on mobile.
 *
 * Reversed order matches legacy: primary action (Contact) appears on the
 * right. Uses `[...ctas].reverse()` rather than `ctas.toReversed()` for
 * Safari 15 compatibility.
 */
export const SpokeFooterCTAs = ({ listing }: Props) => {
  const { ctas, overlays } = useListingCTAs(listing);

  if (ctas.length === 0) return null;

  return (
    <>
      {[...ctas].reverse().map((cta) => (
        <Button
          key={cta.id}
          data-testid={`button-${cta.id}`}
          tone="brand"
          emphasis={cta.emphasis}
          fluid
          onClick={cta.onClick}
          disabled={cta.disabled}
          aria-busy={cta.ariaBusy}
          aria-label={cta.ariaLabel}
        >
          {cta.label}
        </Button>
      ))}
      {overlays}
    </>
  );
};
